import {css, StyleSheet} from 'aphrodite';
import React from 'react';

interface SequenceRangeCellProps {
  start: number;
  end: number;
}

/**
 * Align the range to the center hyphen across all rows.
 */
export default function SequenceRangeCell({start, end}: SequenceRangeCellProps): JSX.Element {
  return (
    <span className={css(styles.container)}>
      <span className={css(styles.start)}>{start}</span>
      <span className={css(styles.hyphen)}>-</span>
      <span className={css(styles.end)}>{end}</span>
    </span>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  start: {
    flex: 1,
    textAlign: 'right',
  },
  hyphen: {
    flexShrink: 0,
    textAlign: 'center',
    alignItems: 'center',
    width: '10px',
    // the natural position of a hyphen is slightly below the middle
    transform: 'translateY(-5%)',
  },
  end: {
    flex: 1,
    textAlign: 'left',
  },
});
